export default function getDomainNameFromEnsDomain(ensDomain: any) {
  const domain = ensDomain.metadata.name.toLowerCase();
  return domain.substr(0, domain.indexOf('.eth'));
}
